const makeTicker = (economy, callbacks) => {
    let apProgress = 0;

    return {
        tick: () => {
            const nextAP = economy.getAdvancementPoints() + 1;
            if (nextAP <= economy.getMaxAdvancementPoints()) {
                const apIncrement = 1/(nextAP*nextAP);
                apProgress += apIncrement;
                if (apProgress > 10) {
                    apProgress = 0;
                    callbacks.addAdvancementPoint();
                }
            }
        },

        getAPProgress: () => apProgress
    }
};

export default makeTicker;